import { render, staticRenderFns } from "./ConfigMenu.vue?vue&type=template&id=484af7a4&scoped=true&"
import script from "./ConfigMenu.vue?vue&type=script&lang=ts&"
export * from "./ConfigMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigMenu.vue?vue&type=style&index=0&id=484af7a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484af7a4",
  null
  
)

export default component.exports